var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompanyTile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150%",
    height: "100%",
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    width: "100%",
    height: "100%",
    d: "M0 4C0 1.79086 1.79086 0 4 0H80V80H4C1.79086 80 0 78.2091 0 76V4Z",
    fill: "#E1F3D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 58.6667H21.3334M21.3334 58.6667H44.6667M21.3334 58.6667V26.4671C21.3334 23.8535 21.3334 22.5458 21.8421 21.5475C22.2895 20.6694 23.0029 19.956 23.8809 19.5086C24.8792 19 26.187 19 28.8005 19H37.2005C39.8141 19 41.1191 19 42.1173 19.5086C42.9954 19.956 43.7112 20.6694 44.1586 21.5475C44.6667 22.5448 44.6667 23.851 44.6667 26.4595V40M44.6667 58.6667H58.6667M44.6667 58.6667V40M58.6667 58.6667H63.3334M58.6667 58.6667V40C58.6667 37.8256 58.6665 36.7389 58.3113 35.8813C57.8376 34.7379 56.93 33.8289 55.7865 33.3552C54.9289 33 53.8405 33 51.6661 33C49.4918 33 48.4046 33 47.547 33.3552C46.4035 33.8289 45.4956 34.7379 45.022 35.8813C44.6667 36.7389 44.6667 37.8256 44.6667 40M28.3334 35.3333H37.6667M28.3334 28.3333H37.6667",
    stroke: "#435B37",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyTile);
export default __webpack_public_path__ + "static/media/companyTile.bb732cc459f3b721b72947346ad5b45c.svg";
export { ForwardRef as ReactComponent };